import {
  Button,
  Col,
  Dropdown,
  Icon,
  Input,
  Menu,
  Modal,
  Row,
  Table,
} from "antd";
import Column from "antd/lib/table/Column";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useWindowSize from "../../../hooks/useWindowSize";
import { getAnimalsByIdentification } from "../../../services/animalService";
import { numberMask } from "../../../services/helpersMethodsService";
import TagStatus from "../tagStatus";
import { logEventError } from "../../../utils/logger";
import { Label } from "./styles";

// import SearchAnimal from "../../components/utils/searchAnimal";

// // Em um form/modal/drawer:
// const [textSearch, setTextSearch] = useState("");
// const [animalId, setAnimalId] = useState(null);
// const [animal, setAnimal] = useState(null);

// <SearchAnimal
//   textSearch={textSearch}
//   setTextSearch={setTextSearch}
//   value={animalId}
//   handleChange={(id, animalSelected) => {
//     setAnimalId(id);
//     setAnimal(animalSelected);
//   }}
//   handleDeselect={(a) => { setAnimalId(null); setAnimal(null); }}
//   showDeselect
// />

function ModalSelectAnimal({
  pageData,
  visible,
  handleSelect,
  handleCancel,
  searchField,
}) {
  const { width } = useWindowSize();
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const { translation } = useSelector((state) => state.app);

  const rowSelection = {
    type: "radio",
    selectedRowKeys: selectedRowKey != null ? [selectedRowKey] : [],
    onSelect: (record) => setSelectedRowKey(record.id),
  };

  const renderFarmStatus = (farmStatus) => {
    if (farmStatus === "A" || farmStatus === "Active")
      return (
        <TagStatus background="#C5F1CA" borderColor="#106518" color="#106518">
          {translation.status.active}
        </TagStatus>
      );
    if (farmStatus === "I" || farmStatus === "X" || farmStatus === "Inactive")
      return (
        <TagStatus background="#FBC7C7" borderColor="#D44C4C" color="#D44C4C">
          {translation.status.inactive}
        </TagStatus>
      );
    if (farmStatus === "S" || farmStatus === "Sold")
      return (
        <TagStatus background="#FEFFF6" borderColor="#A9C133" color="#A9C133">
          {translation.status.sold}
        </TagStatus>
      );
    if (farmStatus === "P" || farmStatus === "Pending")
      return (
        <TagStatus background="#FFDBBC" borderColor="#FE8D2A" color="#FE8D2A">
          {translation.status.pending}
        </TagStatus>
      );
    if (farmStatus === "D" || farmStatus === "Dead")
      return (
        <TagStatus background="#4b4b4b" borderColor="#000" color="#e3e3e3">
          {translation.status.dead}
        </TagStatus>
      );
    if (farmStatus === "T" || farmStatus === "Transfer")
      return (
        <TagStatus background="#c3c3c3" borderColor="#000" color="#000">
          {translation.status.transfer}
        </TagStatus>
      );
    return (
      <TagStatus background="#FBC7C7" borderColor="#D44C4C" color="#D44C4C">
        {translation.status.inactive}
      </TagStatus>
    );
  };

  const handleOk = () => {
    handleSelect(selectedRowKey);
    setSelectedRowKey(null);
  };

  const handleClose = () => {
    setSelectedRowKey(null);
    handleCancel();
  };

  return (
    <Modal
      width={width >= 1440 ? 1000 : 800}
      title={translation.animal.searchAnimal.modalTitle}
      centered
      visible={visible}
      okText={translation.buttons.confirm}
      onCancel={handleClose}
      onOk={handleOk}
    >
      <Table
        rowKey="id"
        size="small"
        rowSelection={rowSelection}
        dataSource={pageData != null ? pageData : []}
        scroll={{ x: true }}
        style={{ width: "100%", margin: "0" }}
        pagination={false}
      >
        <Column
          title={translation.animal.columns.handlingNumber}
          dataIndex={searchField}
          align="left"
          key="identification"
          width={160}
        />
        <Column
          title={translation.animal.columns.status}
          dataIndex="farmStatus"
          key="farmStatus"
          width={100}
          align="left"
          render={renderFarmStatus}
        />
        <Column
          title={translation.animal.columns.picket}
          dataIndex="picketName"
          align="left"
          key="picketName"
          width={140}
        />
        <Column
          title={translation.animal.columns.lot}
          dataIndex="lotName"
          align="left"
          key="lotName"
          width={140}
        />
        <Column
          title={translation.animal.columns.breed}
          dataIndex="breedName"
          key="breedName"
          align="left"
          width={100}
        />
        <Column
          title={translation.animal.columns.gender}
          dataIndex="gender"
          key="gender"
          align="left"
          width={80}
          render={(g) =>
            g === "M"
              ? translation.animal.details.male
              : translation.animal.details.female
          }
        />
        <Column
          title={translation.animal.columns.birthdayMonths}
          dataIndex="birthdayMonth"
          key="birthdayMonth"
          align="left"
          width={80}
          render={(text) =>
            text !== null && text !== undefined ? `${text}m` : ""
          }
        />
        <Column
          title={translation.animal.columns.currentWeight}
          dataIndex="lastDailyWeight"
          key="lastDailyWeight"
          align="left"
          width={100}
          render={(text) => `${numberMask(text || 0, false)}kg`}
        />
        <Column
          title={translation.animal.columns.gdp}
          dataIndex="lastDailyWeightGain"
          key="lastDailyWeightGain"
          align="left"
          width={80}
          render={(text) => `${numberMask(text || 0, false)} Kg`}
        />
        <Column
          title={translation.animal.columns.lastDailyWeightDate}
          dataIndex="lastDailyWeightDate"
          key="lastDailyWeightDate"
          align="left"
          width={110}
          render={(text) => (text ? moment(text).format("DD/MM/YYYY") : "")}
        />
        <Column
          title={translation.animal.columns.weightRanking}
          dataIndex="currentWeightRanking"
          key="currentWeightRanking"
          align="center"
          width={90}
          render={(text) =>
            text === "top"
              ? "Cabeceira"
              : text === "medium"
                ? "Meio"
                : text === "worst"
                  ? "Fundo"
                  : null
          }
        />
      </Table>
    </Modal>
  );
}

function SearchAnimal({
  textSearch,
  setTextSearch,
  value,
  handleChange,
  handleDeselect,
  showDeselect = false,
  specificGender: specificGenderProp = undefined,
  inputRef = null,
  hasError = false,
}) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [internalSearchField, setInternalSearchField] =
    useState("handlingNumber");
  const [showError, setShowError] = useState(false);

  const searchField = internalSearchField;
  const setSearchField = setInternalSearchField;

  const specificGender =
    specificGenderProp !== "" && specificGenderProp !== undefined
      ? specificGenderProp
      : undefined;

  const {
    translation,
    groupSelected: { id: groupId },
    farmSelected: { id: farmId },
  } = useSelector((state) => state.app);

  const getSearchFieldLabel = useCallback(
    (field) => translation.animal.searchAnimal[field],
    [translation],
  );

  const handleSearch = useCallback(async () => {
    if (textSearch && textSearch.trim()) {
      setIsLoading(true);
      try {
        const {
          data: { results },
        } = await getAnimalsByIdentification({
          groupId,
          farmId,
          identification: textSearch.trim(),
          identificationType: searchField,
          specificGender,
        });
        setData(results || []);
        if (results && results.length > 1) {
          setModalVisible(true);
          setShowError(false);
        } else if (results && results.length === 1) {
          const animal = results[0];
          const displayValue =
            animal[searchField] ?? animal.handlingNumber ?? "";
          setTextSearch(displayValue);
          handleChange(animal.id, animal, searchField);
          setShowError(false);
        } else {
          setData([]);
          setShowError(true);
        }
      } catch (err) {
        logEventError("SearchAnimal - handleSearch - error", err);
        setShowError(true);
        setData([]);
      } finally {
        setIsLoading(false);
      }
    } else {
      setData([]);
    }
  }, [
    farmId,
    groupId,
    searchField,
    textSearch,
    specificGender,
    handleChange,
    setTextSearch,
  ]);

  const handleCancelModal = useCallback(() => {
    setModalVisible(false);
    setData([]);
  }, []);

  const handleSelectModal = useCallback(
    (selectedId) => {
      setModalVisible(false);
      const animal = data.find((a) => a.id === selectedId);
      if (animal) {
        const displayValue = animal[searchField] ?? animal.handlingNumber ?? "";
        setTextSearch(displayValue);
        handleChange(selectedId, animal);
      }
      setData([]);
    },
    [data, searchField, handleChange, setTextSearch],
  );

  const handleDeselectModal = useCallback(() => {
    setModalVisible(false);
    setTextSearch(null);
    setData([]);
    handleDeselect();
  }, [setTextSearch, handleDeselect]);

  const handleEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    }
  };

  useEffect(() => {
    setShowError(false);
  }, []);

  return (
    <>
      <Row>
        <Col span={24}>
          <Label className={hasError ? "error" : ""}>
            {translation.animal.searchAnimal.label}: (
            {getSearchFieldLabel(searchField)})
          </Label>
        </Col>
      </Row>
      <Row type="flex" gutter={8}>
        <Col span={14}>
          <Input
            ref={inputRef}
            placeholder={translation.defaultPlaceholder}
            disabled={isLoading}
            value={textSearch}
            onKeyDown={handleEnter}
            onChange={(e) => setTextSearch(e.target.value)}
          />
          {showError && (
            <Row type="flex" justify="center" align="middle">
              <p style={{ color: "red", marginTop: 4 }}>
                {translation.error && translation.error.animalNotFound
                  ? translation.error.animalNotFound
                  : "Animal não encontrado"}
              </p>
            </Row>
          )}
        </Col>
        <Col>
          {isLoading ? (
            <Icon type="loading" />
          ) : (
            <Button shape="circle" icon="search" onClick={handleSearch} />
          )}
          <Dropdown
            placement="bottomRight"
            trigger={["click"]}
            key={"dropdown-search-field"}
            overlay={() => (
              <Menu id="dropdown-search-field">
                <Menu.Item onClick={() => setSearchField("handlingNumber")}>
                  {getSearchFieldLabel("handlingNumber")}
                </Menu.Item>
                <Menu.Item onClick={() => setSearchField("sisbov")}>
                  {getSearchFieldLabel("sisbov")}
                </Menu.Item>
                <Menu.Item onClick={() => setSearchField("tagId")}>
                  {getSearchFieldLabel("tagId")}
                </Menu.Item>
                <Menu.Item onClick={() => setSearchField("registry")}>
                  {getSearchFieldLabel("registry")}
                </Menu.Item>
                <Menu.Item onClick={() => setSearchField("nickname")}>
                  {getSearchFieldLabel("nickname")}
                </Menu.Item>
              </Menu>
            )}
          >
            <Button style={{ marginLeft: 8 }} shape="circle" icon="filter" />
          </Dropdown>
        </Col>
        {showDeselect && value !== null && value !== undefined && (
          <Col span={4}>
            {!isLoading && (
              <Button
                shape="circle"
                icon="close"
                onClick={handleDeselectModal}
              />
            )}
          </Col>
        )}
      </Row>
      <ModalSelectAnimal
        pageData={data}
        visible={modalVisible}
        searchField={searchField}
        handleSelect={handleSelectModal}
        handleCancel={handleCancelModal}
      />
    </>
  );
}

export default SearchAnimal;
